import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { ConstantsService } from '../service/constants.service';

@Injectable({
  providedIn: 'root'
})
export class ReasonidService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	loadReasonId(): Observable<any> {
		return this.http
		  .get(`${this.constantsService.baseAPIURL}/eboi/masterSetting/getReasons`, this.constantsService.httpCustomOptions)
		  .pipe(
			catchError(this.handleError));
	}
	loadCategoryIdDropDown() : Promise<any>{
		return this.http
				.get(`${this.constantsService.baseAPIURL}/eboi/home/drpDwn/category`, this.constantsService.httpCustomOptions)
				.pipe(map(res => res))
				.toPromise();
	  }
	

	loadTargets(): Observable<any> {
		return this.http
		  .get(`${this.constantsService.baseAPIURL}/eboi/masterSetting/getTargets`, this.constantsService.httpCustomOptions)
		  .pipe(
			catchError(this.handleError));
	}
	domicileDrpDwn() : Promise<any>{
		return this.http
				.get(`${this.constantsService.baseAPIURL}/eboi/home/drpDwn/domiciles`, this.constantsService.httpCustomOptions)
				.pipe(map(res => res))
				.toPromise();
	  }

	copyTargets(fromPeriod, toPeriod): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/masterSetting/copyAllTargets/${fromPeriod}/${toPeriod}`,{}, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	getPeriodsList(): Observable<any> {
		return this.http
		  .get(`${this.constantsService.baseAPIURL}/eboi/getPeriods`, this.constantsService.httpCustomOptions)
		  .pipe(
			catchError(this.handleError));
	}

	addReasonId(addObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/masterSetting/saveReason`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	addTargets(addObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/masterSetting/saveTarget`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	  
	updateReasonId(updateObject): Observable<any> {
		return this.http.put(` ${this.constantsService.baseAPIURL}/eboi/masterSetting/editReason`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateTargets(updateObject): Observable<any> {
		return this.http.put(` ${this.constantsService.baseAPIURL}/eboi/masterSetting/editTarget`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	deleteReasonId(reasonId): Observable<any> {
	return this.http
		.delete(`${this.constantsService.baseAPIURL}/eboi/masterSetting/deleteReason/${reasonId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
		.pipe(
		catchError(this.handleError));
	}

	deleteTargets(reasonId): Observable<any> {
	return this.http
		.delete(`${this.constantsService.baseAPIURL}/eboi/masterSetting/deleteTarget/${reasonId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
		.pipe(
		catchError(this.handleError));
	}
	//rootcause
	loadRootCause(): Observable<any> {
		return this.http
		  .get(`${this.constantsService.baseAPIURL}/eboi/masterSetting/getRootCauses`, this.constantsService.httpCustomOptions)
		  .pipe(
			catchError(this.handleError));
	}

addRootCause(addObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/masterSetting/saveRootCause`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	  
	updateRootCause(updateObject): Observable<any> {
		return this.http.put(` ${this.constantsService.baseAPIURL}/eboi/masterSetting/editRootCause`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

deleteRootCause(rootCauseId): Observable<any> {
		return this.http
			.delete(`${this.constantsService.baseAPIURL}/eboi/masterSetting/deleteRootCause/${rootCauseId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
			catchError(this.handleError));
		}

	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}

}

